import { getQuerys, loadTokenfromSessionStorage } from './Utils';
import { clearTokenAndRedirect } from './auth';

export const _fetch = async ({ api, data = {}, method = 'GET', options = {
  
}, params = {}, headers = {
  'Content-Type': 'application/json;charset=utf-8',
  'Authorization': loadTokenfromSessionStorage(),
}, file = null }) => {

  let formData = null;
  let _method = method;
  let _headler = {
    ...headers
  };

  if (file) {
    formData = new FormData();
    formData.append('file', file);
    _method = 'POST';
    delete _headler['Content-Type'];
  }

  const _options = {
    ...options,
    method: _method,
    headers: {
      ..._headler
    },
  }

  if (_method.toLocaleUpperCase() === 'POST' ||  _method.toLocaleUpperCase() === 'PUT') {
    _options.body = !!file ? formData : JSON.stringify(data);
  }

  return fetch(`${api}${getQuerys(params)}`, {
    ..._options,
  })
    .then(async (res) => {
      if (res.status === 401) {
          clearTokenAndRedirect();
          return;
      }
      return res.json();
  });
};